module.exports = __webpack_public_path__ + "static/media/Icon material-more-vert.d2ffb98b.svg";